import { Reveal } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

const Manifesto = () => {
  const { t } = useLanguage();

  const manifestoChapters = [
    { num: "01", title: t("manifesto.m1Title"), desc: t("manifesto.m1Desc") },
    { num: "02", title: t("manifesto.m2Title"), desc: t("manifesto.m2Desc") },
    { num: "03", title: t("manifesto.m3Title"), desc: t("manifesto.m3Desc") },
  ];

  const marqueeItems = [
    "Vasavi Gold",
    "Premium Quality Rice",
    "Trusted Every Grain",
    "Family Owned Since 1975",
    "Chemudulanka · Andhra Pradesh",
  ];

  return (
    <section className="relative bg-white overflow-hidden" data-testid="manifesto-section">
      {/* Numbered chapters */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-36">
        <div className="flex items-center gap-3 mb-16">
          <span className="h-px w-8 bg-[#d4af37]" />
          <span className="eyebrow">{t("manifesto.eyebrow")}</span>
        </div>

        <div className="space-y-16 md:space-y-24">
          {manifestoChapters.map((c, i) => (
            <div
              key={c.num}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start border-t border-[#40916c]/10 pt-10 md:pt-14"
              data-testid={`manifesto-${i}`}
            >
              <Reveal className="md:col-span-3">
                <span className="font-display text-6xl md:text-7xl font-bold text-[#40916c]/25">{c.num}</span>
              </Reveal>
              <Reveal delay={0.1} className="md:col-span-9">
                <h3 className="font-display text-3xl md:text-5xl font-semibold text-[#222222] tracking-tight leading-[1.05] max-w-3xl">
                  {c.title}
                </h3>
                <p className="font-body text-base md:text-lg text-[#5b6b62] leading-relaxed mt-6 max-w-2xl">
                  {c.desc}
                </p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>

      {/* Slow editorial marquee */}
      <div className="relative py-10 md:py-14 bg-[#40916c] overflow-hidden select-none" aria-hidden>
        <div className="marquee marquee-slow">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center shrink-0">
              {marqueeItems.map((t, i) => (
                <span key={`${dup}-${i}`} className="flex items-center">
                  <span className="font-display text-4xl md:text-6xl font-semibold text-white/95 px-8 tracking-tight whitespace-nowrap">
                    {t}
                  </span>
                  <span className="h-2.5 w-2.5 rounded-full bg-[#d4af37]" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
